import React, {type Ref} from "react";
import {css, cx} from "@panda/css";

import {Col} from "@pg-design/grid-module";

interface IProps {
    children?: React.ReactNode;
    "data-testid"?: string;
    id?: string;
    className?: string;
    style?: React.CSSProperties;
    dynamicProps?: Record<string, string | number>;
    customGridStyle?: {flex: string; maxWidth: string} | null;
    ref?: Ref<HTMLDivElement | null>;
}

export function ColumnListItem(props: IProps) {
    const {ref, customGridStyle, children, className, dynamicProps, id, style} = props;

    const combinedStyle = customGridStyle ? {...style, ...customGridStyle} : style;

    return (
        <Col
            {...(dynamicProps || {})}
            ref={ref}
            id={id}
            data-testid={props["data-testid"]}
            sm={4}
            md={4}
            lg={4}
            style={combinedStyle}
            className={cx(colStyle, className)}
            as="li"
        >
            {children}
        </Col>
    );
}

const colStyle = css({
    display: "flex",
    justifyContent: "center"
});
import React, {type Ref} from "react";
import {css, cx} from "@panda/css";

import {Col} from "@pg-design/grid-module";

interface IProps {
    children?: React.ReactNode;
    "data-testid"?: string;
    id?: string;
    className?: string;
    style?: React.CSSProperties;
    dynamicProps?: Record<string, string | number>;
    customGridStyle?: {flex: string; maxWidth: string} | null;
    ref?: Ref<HTMLDivElement | null>;
}

export function ColumnListItem(props: IProps) {
    const {ref, customGridStyle, children, className, dynamicProps, id, style} = props;

    const combinedStyle = customGridStyle ? {...style, ...customGridStyle} : style;

    return (
        <Col
            {...(dynamicProps || {})}
            ref={ref}
            id={id}
            data-testid={props["data-testid"]}
            sm={4}
            md={4}
            lg={4}
            style={combinedStyle}
            className={cx(colStyle, className)}
            as="li"
        >
            {children}
        </Col>
    );
}

const colStyle = css({
    display: "flex",
    justifyContent: "center"
});
